import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Flag(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    d: "M5.204 3.597L3 22h3.843l.512-5.895c.399-1.63 1.286-2.156 2.532-2.875l9.017-3.834C19.552 9.156 20 8.58 20 7.91c0-.67-.448-1.246-1.096-1.486L7.794 2.16c-1.61-.383-2.214-.139-2.59 1.438z"
  }));
}

export default Flag;